import SimpleMarkdown from "@khanacademy/simple-markdown";

import type {MarkdownRule} from "../types.ts";

// TODO(GL-454): Remove this rule override when we land the fix in Perseus
// and update the package.
export const textRule: Readonly<MarkdownRule> = {
    ...SimpleMarkdown.defaultRules.text,
    // Slightly modified from SimpleMarkdown's text rules to include a
    // negative look-ahead of `\d+\.` so that we don't break up ordered lists
    // unexpectedly.
    match: SimpleMarkdown.anyScopeRegex(
        /^[\s\S]+?(?=[^0-9A-Za-z\s\u00c0-\uffff]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/,
    ),
    // Needed to explicitly include the react output to appease Flow
    react: (node, output, state) => node.content,
};
